import { Link } from 'react-router-dom';
import { buildCtaHref } from '@/lib/cta';
import type { CtaBlock as CtaBlockData } from '@/types/cta';

interface Props {
  cta: CtaBlockData;
  context?: { slug?: string; title?: string };
}

function isExternalHref(href: string): boolean {
  return /^https?:\/\//.test(href) || href.startsWith('mailto:');
}

export const CtaBlock = ({ cta, context }: Props): React.JSX.Element => {
  const href = buildCtaHref(cta, context);
  const buttonClass = cta.buttonStyle === 'secondary' ? 'button button--ghost' : 'button button--primary';

  return (
    <section className="cta-block">
      <div className="cta-block__content">
        <p className="cta-block__eyebrow">Next step</p>
        <h2 className="cta-block__headline">{cta.headline}</h2>
        {cta.body ? <p className="cta-block__body">{cta.body}</p> : null}
      </div>
      <div className="cta-block__actions">
        {isExternalHref(href) ? (
          <a className={buttonClass} href={href}>
            {cta.actionLabel}
          </a>
        ) : (
          <Link className={buttonClass} to={href}>
            {cta.actionLabel}
          </Link>
        )}
      </div>
    </section>
  );
};
